import { useEffect, useState } from "react";
import {
  Box,
  Stack,
  TextField,
  Button,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";

import { Strings } from "@app/constants";
import { useRequestState, useResponsive } from "@app/hooks";
import { AddBrandModal } from "./add-brand-modal";
import { brand } from "../slice";
import { selectBrandState, selectDeleteBrandState } from "../selector";
import { IBrandData } from "../types";
import { BrandCard } from "./brand-card";
import { useTheme } from "@mui/material/styles";
import { Icon } from "@iconify/react";

const BrandPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [query, setQuery] = useState<string>("");
  const [openModal, setOpenModal] = useState<boolean>(false);

  const { data } = useRequestState({
    stateSelector: selectBrandState,
    errorShown: true,
  });

  useRequestState({
    stateSelector: selectDeleteBrandState,
    errorShown: true,
    successMessageShown: true,
  });

  useEffect(() => {
    dispatch(brand());
  }, [dispatch]);

  const filteredBrands = (data || [])?.filter((brand: IBrandData) =>
    brand?.name?.toLowerCase()?.includes(query?.toLowerCase())
  );

  const handleSubmit = () => {
    setOpenModal(false);
  };

  const brands = query ? filteredBrands : data;

  const isMobile = useResponsive("down", "sm");

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#fff",
        borderRadius: 1,
        minHeight: { xs: "auto", md: "calc(100vh - 64px)" },
        boxSizing: "border-box",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="space-between"
        mb={3}
        alignItems={"center"}
      >
        <TextField
          fullWidth
          placeholder="Search"
          value={query}
          onChange={(e:any) => setQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Icon icon="mdi:magnify" />
              </InputAdornment>
            ),
            sx: { backgroundColor: "#fff" },
          }}
        />

        <Button
          variant="contained"
          sx={{
            borderRadius: 1,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            width: { xs: "100%", sm: 150 },
            height: {xs:40,sm : 50}
          }}
          onClick={() => setOpenModal(true)}
        >
          {Strings.button.addBrand}
        </Button>
      </Stack>
      <Stack
        direction={"row"}
        flexWrap={"wrap"}
        gap={2}
        alignItems={"center"}
        justifyContent={isMobile ? "center" : "start"}
      >
        {brands?.length <= 0 ? 
        <Stack>
          <Typography>No Car Found</Typography>
        </Stack>
        :
          brands?.map((item: IBrandData) => {
            return <BrandCard item={item} />;
          })}
      </Stack>
      <AddBrandModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onSubmit={handleSubmit}
        selectedBrandData={null}
      />
    </Box>
  );
};

export { BrandPage };
